module.exports = __webpack_public_path__ + "img/4.715744d6.svg";